import script from "./ChatTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatTab.vue?vue&type=script&setup=true&lang=js"

import "./ChatTab.vue?vue&type=style&index=0&id=1a6d28cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6d28cb"]])

export default __exports__